import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';

import { Route } from 'app/interfaces/api/types';

import { RouteService } from 'app/services';

@Component({
  selector: 'app-single-route',
  templateUrl: './single-route.page.html',
  styleUrls: ['./single-route.page.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SingleRoutePage implements OnInit {
  public route: Route;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navCtrl: NavController,
    private readonly routeService: RouteService
  ) {
  }

  ngOnInit(): void { }

  ionViewWillEnter(): void {
    this.reset();
  }

  async ionViewDidEnter(): Promise<void> {
    const slug: string = this.activatedRoute.snapshot.paramMap.get('slug');

    this.route = await this.routeService.getBySlug(slug);
  }

  public goBack(): void {
    this.navCtrl.back();
  }

  private reset(): void {
    this.route = null;
  }
}
